


import React, { useState,useRef } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Typography,
  IconButton,
  Button,
  InputBase,
  Select,
  Pagination,
  MenuItem,
  Menu,
  TablePagination,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SearchIcon from '@mui/icons-material/Search';
import CustomText, { textStyles } from "../../../../components/CustomText";
import arrow from "../../../../assets/arrow.svg";
import invited from "../../../../assets/Dashboard/invited.svg";
import tablefilter from "../../../../assets/tablefilter.svg";
import clienttrial from "../../../../assets/Dashboard/clienttrial.svg";
import ClientsTrialDetails from '../../ClientAcquisition/ClientsTrial/ClientTrialDetails';
import { pdf } from '@react-pdf/renderer';
import { CircularProgress } from '@mui/material';
import active from "../../../../assets/Dashboard/active.svg";
import inactive from "../../../../assets/Dashboard/inactive.svg"
import InactiveCompaniesPDF from './InactiveCompaniesPDF';
import FilterDrawer from './FilterDrawer';
import InactiveDetails from './InactiveDetails';
import StatusDropdown from '../../../../components/StatusDropdown';
import ExportDropdown from '../../../../components/ExportDropdown';
import VisibilityIcon from '@mui/icons-material/Visibility';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { toast ,Toaster} from 'react-hot-toast';
import { BASE_URL } from '../../../../components/BaseUrl';
import { decryptToken } from "../../../../Utlis/Encryption";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import emptyscreen from "../../../../assets/Dashboard/emptyscreen.svg"
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ArrowStatusDropdown from '../../../../components/ArrowStatusDropdown';
import ExportInactiveCompaniesExcel from "./InactiveExcel";
import InActivePins from './InactivePins';
import { convertUTCToLocalDateTime } from "../../../../components/dateTime";
const InactiveCompanies= () => {
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const rowsPerPage = 6;
  const [loading, setLoading] = useState(true);
const [selectedClientId, setSelectedClientId] = useState(null);
     const rawEncryptedToken = localStorage.getItem("token");
      const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
      const [sortLoading, setSortLoading] = useState(false);

const { t } = useTranslation();
const navigate = useNavigate();
const columns = [
  { key: 'id', label: t('inactiveCompanies.columns.id') },
  { key: 'admin', label: t('inactiveCompanies.columns.admin') },
  { key: 'company', label: t('inactiveCompanies.columns.company') },
  { key: 'country', label: t('inactiveCompanies.columns.country') },
   { key: 'email', label: t('activeCompanies.columns.email') },
    { key: 'active', label: t('activeUsers') },
  { key: 'usage', label: t('maxUsers') },
     { key: 'subscription', label: t('subscriptionPlan') },
       { key: 'subscriptionStatus', label: t('subscriptionStatus') },

  { key: 'details', label: t('inactiveCompanies.columns.details') },
  { key: 'status', label: t('inactiveCompanies.columns.status') },
    {key: 'verificationStatus', label: t("invites.columns.verificationStatus") },
  { key: 'date', label: t('DateTime') },
   { key: 'subscriptionPeriod', label: t("subscriptionPeriod") },
{ key: 'trialPeriod', label: t("trialPeriod") },
  { key: 'action', label: t('inactiveCompanies.columns.action') }
];

  const handleSelect = (id) => {
    setSelected(prev =>
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const handleChangePage = (_, newPage) => setPage(newPage);

const HaederStyles = {
  color: "#44546F",
  fontSize: "12px",
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 600,

};
const DataStyles = {
  color: "#172B4D",
  fontSize: "12px",
  fontFamily: 'Poppins, sans-serif',
  fontWeight: 400,
    whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
};
const statusStyles = {
  Requested: { backgroundColor: '#F5CD47', color: '#533F04' },
  Invited: { backgroundColor: '#579DFF', color: '#09326C' }, // optional fallback style
   Trial: { backgroundColor: '#FEA362', color: '#702E00' },
      Active: { backgroundColor: '#4BCE97', color: '#164B35' },
            Inactive: { backgroundColor: '#F87168', color: '#5D1F1A' },
};
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loadingExport, setLoadingExport] = useState(false);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
const [filters, setFilters] = useState({
  subscription_plan: '',
  subscription_status: '',
  verification_status: '',
  start_date: '',
  end_date: '',
   country:'',
  state:'',
  city:''
});

const INITIAL_FILTERS = {
  subscription_plan: '',
  subscription_status: '',
  verification_status: '',
  start_date: '',
  end_date: '',
   country:'',
  state:'',
  city:''
};

          const statusButtonStyles = {
    active: { backgroundColor: '#4BCE97', color: '#164B35'},
    inactive: { backgroundColor: ' #F87168', color: '#5D1F1A' },
      requested: {  backgroundColor: '#F5CD47', color: '#533F04'  },
         invited: { backgroundColor: '#579DFF', color: '#09326C' },
          verified: { backgroundColor: '#2196F3', color: '#0D47A1' },
   rejected: { backgroundColor: '#F87168', color: '#5D1F1A' },
pending: { backgroundColor: '#F5CD47', color: '#533F04' },
};
const [searchTerm, setSearchTerm] = useState('');
//  const [originalRows, setOriginalRows] = useState(data);
const [originalRows, setOriginalRows] = useState([]);
const [totalPages, setTotalPages] = useState(1);
  // const [tableRows, setTableRows] = useState(data);
  const [tableRows, setTableRows] = useState([]);
  const [statusUpdating, setStatusUpdating] = useState(null);
const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });
const sortTriggeredByUser = useRef(false);
const handleSort = (columnKey) => {
  const direction =
    sortConfig.key === columnKey && sortConfig.direction === 'asc' ? 'desc' : 'asc';

  sortTriggeredByUser.current = true; // Mark as user-triggered
  setSortConfig({ key: columnKey, direction });
};
  const filteredRows = originalRows;


  // const paginatedRows = sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const allSelected = tableRows.length > 0 && selected.length === tableRows.length;
const isIndeterminate = selected.length > 0 && !allSelected;

const [firstLoadDone, setFirstLoadDone] = useState(false);
  const [tableProcessing, setTableProcessing] = useState(false);

  const planNameMap = {
  attendance_yearly: "Attendance Yearly",
  attendance_monthly: "Attendance Monthly",
  full_monthly: "Full Monthly",
  full_yearly: "Full Yearly",
};
const fetchInactiveCompanies = async (
  pageNum = 0,
  limit = 6,
  sortBy = 'email',
  sortOrder = 'asc',
  isSortTriggered = false,
  keyword = '',
  appliedFilters = {}
) => {
  console.log("🚀 ===== FETCH INACTIVE COMPANIES START =====");
  console.log("🚀 Parameters received:", {
    pageNum, 
    limit, 
    sortBy, 
    sortOrder, 
    isSortTriggered, 
    keyword, 
    appliedFilters
  });

  const isInitialLoad = !firstLoadDone;

  if (isInitialLoad) {
    setLoading(true);
  } else {
    setTableProcessing(true);
  }

  try {
    const queryParams = new URLSearchParams({
      page: pageNum + 1,
      limit,
      sort_by: sortBy,
      sort_order: sortOrder.toUpperCase(),
      status: 'inactive',
    });

    console.log("🔧 Base query params:", Object.fromEntries(queryParams));

    if (keyword) {
      queryParams.append('search', keyword);
      console.log("🔍 Added search keyword:", keyword);
    }
// COUNTRY filter
if (appliedFilters.country) {
  queryParams.append('country', appliedFilters.country);
}

// STATE filter (province → state for backend)
if (appliedFilters.state) {
  queryParams.append('state', appliedFilters.state);
}

// CITY filter
if (appliedFilters.city) {
  queryParams.append('city', appliedFilters.city);
}
if (appliedFilters.subscription_plan) {
  queryParams.append('subscription_plan', appliedFilters.subscription_plan);
}

if (appliedFilters.subscription_status) {
  queryParams.append('subscription_status', appliedFilters.subscription_status);
}

if (appliedFilters.verification_status && appliedFilters.verification_status !== 'all') {
  queryParams.append('verification_status', appliedFilters.verification_status);
}

if (appliedFilters.start_date) {
  queryParams.append('start_date', appliedFilters.start_date);
}
if (appliedFilters.end_date) {
  queryParams.append('end_date', appliedFilters.end_date);
}
if (appliedFilters.trial_end_date_from) {
  queryParams.append(
    "trial_end_date_from",
    appliedFilters.trial_end_date_from
  );
}

if (appliedFilters.trial_end_date_to) {
  queryParams.append(
    "trial_end_date_to",
    appliedFilters.trial_end_date_to
  );
}

if (appliedFilters.subscription_start_date_from) {
  queryParams.append(
    "subscription_start_date_from",
    appliedFilters.subscription_start_date_from
  );
}

if (appliedFilters.subscription_start_date_to) {
  queryParams.append(
    "subscription_start_date_to",
    appliedFilters.subscription_start_date_to
  );
}
    const url = `${BASE_URL}/company-admins?${queryParams.toString()}`;
    console.log("🌐 Final API URL:", url);
    console.log("🌐 All Query Parameters:", Object.fromEntries(queryParams));

    const res = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    console.log("📡 HTTP Response Status:", res.status);
    console.log("📡 Response OK:", res.ok);

    const result = await res.json();
    console.log("📡 Complete API Response:", result);

    if (!result.error && result.data?.company_admins) {
      console.log("✅ API Success - Raw Data Analysis:");
      console.log("✅ Total records returned:", result.data.company_admins.length);
      console.log("✅ Pagination info:", result.data.pagination);
      
      if (result.data.company_admins.length > 0) {
        console.log("✅ Sample raw records (first 3):");
        result.data.company_admins.slice(0, 3).forEach((admin, index) => {
          console.log(`   Record ${index + 1}:`, {
            id: admin.id,
            full_name: admin.full_name,
             email: admin.email,
            company_name: admin.company_name,
            subscription_plan: admin.subscription_plan,
            subscription_status: admin.subscription_status,
            status: admin.status,
            verification_status: admin.verification_status
          });
        });
      } else {
        console.log("⚠️ No records returned from API");
        console.log("⚠️ This means your filters don't match any data in the database");
        console.log("⚠️ Applied filters were:", appliedFilters);
      }

      const parsed = result.data.company_admins.map((admin, index) => {
        // Log each record processing
        console.log(`🔄 Processing record ${index + 1} (ID: ${admin.id}):`);
        console.log(`   Original subscription_plan:`, admin.subscription_plan);
        console.log(`   Original subscription_status:`, admin.subscription_status);

        // Normalize subscription data
        let normalizedSubscription = 'N/A';
        try {
          if (typeof admin.subscription_plan === 'string') {
            try {
              const parsed = JSON.parse(admin.subscription_plan);
              normalizedSubscription = typeof parsed === 'object' 
                ? Object.keys(parsed)[0] || 'N/A'
                : admin.subscription_plan;
            } catch {
              normalizedSubscription = admin.subscription_plan;
            }
          } else if (typeof admin.subscription_plan === 'object') {
            normalizedSubscription = Object.keys(admin.subscription_plan)[0] || 'N/A';
          } else {
            normalizedSubscription = admin.subscription_plan || 'N/A';
          }
        } catch (err) {
          console.warn(`   Error normalizing subscription for record ${admin.id}:`, err);
          normalizedSubscription = 'N/A';
        }

        console.log(`   Normalized subscription:`, normalizedSubscription);
const formatRange = (start, end) => {
  if (!start && !end) return "-";

  const format = (d) =>
    d
      ? convertUTCToLocalDateTime(d, {
          formatOptions: {
            day: "2-digit",
            month: "short",
            year: "numeric",
          },
        })
      : "-";

  return `${format(start)} - ${format(end)}`;
};
        const processedRecord = {
          id: admin.id,
          admin: admin.full_name,
          company: admin.company_name,
          country: admin.country,
          active:admin.current_employees,
          usage: admin.max_employees,
                       businessEmail:admin.business_email,
email:admin.email,
          // subscription: normalizedSubscription,
          subscription: planNameMap[normalizedSubscription] || normalizedSubscription,
          subscription_raw: admin.subscription_plan,
          subscriptionStatus: admin.subscription_status,
          subscription_status_raw: admin.subscription_status,
          details: admin.subscription_status === 'trial' ? 'Trial Ended' : 'Subscription Ended',
          status: (admin.status || '').toLowerCase(),
          verificationStatus: (admin.verification_status || '').toLowerCase(),
        date: convertUTCToLocalDateTime(admin.created_at),
          subscriptionPeriod: formatRange(
    admin.subscription_start_date,
    admin.subscription_end_date
  ),

  trialPeriod: formatRange(
    admin.trial_start_date,
    admin.trial_end_date
  ),
        };

        return processedRecord;
      });

      console.log("✅ Final processed data:");
      console.log("✅ Total processed records:", parsed.length);
      if (parsed.length > 0) {
        console.log("✅ Sample processed records:", parsed.slice(0, 2));
      }
      
      setOriginalRows(parsed);
      setTableRows(parsed);
      setTotalPages(result.data.pagination.pages || 1);

    } else {
      console.error("❌ API Error or No Data:");
      console.error("   Error flag:", result.error);
      console.error("   Message:", result.message);
      console.error("   Data structure:", result.data);
      toast.error(result.message || "Failed to fetch data");
    }
  } catch (err) {
    console.error("❌ Network/Fetch Error:", err);
    console.error("❌ Error details:", {
      name: err.name,
      message: err.message,
      stack: err.stack
    });
    toast.error("Error fetching data");
  } finally {
    console.log("🏁 fetchInactiveCompanies completed");
    console.log("🏁 ===== FETCH INACTIVE COMPANIES END =====");
  setLoading(false);
    setTableProcessing(false);
    setFirstLoadDone(true); 
  }
};
const isFilterApplied = Object.values(filters).some(f => f && f !== '');

useEffect(() => {
  const delayDebounce = setTimeout(() => {
    fetchInactiveCompanies(
      page,
      rowsPerPage,
      sortConfig.key || 'email',
      sortConfig.direction || 'asc',
      false,
      searchTerm,
      filters
    );
  }, 500);

  return () => clearTimeout(delayDebounce);
}, [searchTerm, page, rowsPerPage, filters]); 
// useEffect(() => {
//   fetchInactiveCompanies(page, rowsPerPage, sortConfig.key || 'email', sortConfig.direction || 'asc', true);
// }, [sortConfig]);

useEffect(() => {
  // Only fetch with sort loading if user explicitly triggered sorting
  if (sortConfig.key && sortTriggeredByUser.current) {
    fetchInactiveCompanies(page, rowsPerPage, sortConfig.key, sortConfig.direction, true);
    sortTriggeredByUser.current = false; // Reset after use
  }
}, [sortConfig, page, rowsPerPage]);

const handleStatusUpdate = async (status) => {
  if (selected.length === 0) {
    toast.error("No companies selected");
    return;
  }

  setStatusUpdating(status);

  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;

  const payload = {
    company_admin_ids: selected,
    status: status,
    verification_status: 'verified',
  };

  try {
    const res = await fetch(`${BASE_URL}/company-admins/status`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const result = await res.json();
    if (result.error === false) {
      toast.success(result.message || `Status updated to "${status}"`);

      // const updated = tableRows.map((row) =>
      //   selected.includes(row.id)
      //     ? { ...row, status }
      //     : row
      // );

      // setTableRows(updated);
          const updated = tableRows.map((row) => {
  if (selected.includes(row.id)) {
    // const cleanedSubscription =
    //   typeof row.subscription === 'string'
    //     ? row.subscription
    //     : Object.keys(row.subscription)[0] || 'N/A';
    let cleanedSubscription;
try {
  if (typeof row.subscription === 'string') {
    const parsed = JSON.parse(row.subscription);
    cleanedSubscription = typeof parsed === 'object'
      ? Object.keys(parsed)[0] || 'N/A'
      : row.subscription;
  } else if (typeof row.subscription === 'object') {
    cleanedSubscription = Object.keys(row.subscription)[0] || 'N/A';
  } else {
    cleanedSubscription = row.subscription || 'N/A';
  }
} catch {
  cleanedSubscription = row.subscription || 'N/A';
}

    return {
      ...row,
      status,
      subscription: cleanedSubscription,
    };
  }
  return row;
});

setTableRows(updated);
      setSelected([]);
    } else {
      toast.error(result.message || "Failed to update status");
    }
  } catch (err) {
    console.error("Status update failed:", err);
    toast.error("Something went wrong while updating status.");
  } finally {
    setStatusUpdating(null);
  }
};
const statusValues = ['active', 'inactive', 'invited', 'requested'];

const statusOptions = statusValues.map((value) => ({
  label: t(`statusOptions.${value}`),
  value,
}));
const [verifyingId, setVerifyingId] = useState(null);
const handleVerificationStatusUpdate = async (verificationStatus, id) => {
  if (!id) {
    toast.error("No ID selected.");
    return;
  }
 setVerifyingId(id); 
  const payload = {
    company_admin_ids: [id],
    status: tableRows.find(row => row.id === id)?.status || 'invited', // keep current status
    verification_status: verificationStatus,
  };

  const url = `${BASE_URL}/company-admins/status`;

  try {
    const res = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const result = await res.json();

    if (result.error === false) {
      toast.success(`Verification status updated to "${verificationStatus}"`);

      const updated = [...tableRows];
      const index = updated.findIndex(row => row.id === id);
      if (index !== -1) {
        updated[index].verificationStatus = verificationStatus;
        setTableRows(updated);
      }
    } else {
      toast.error(result.message || "Failed to update verification status");
    }
  } catch (err) {
    console.error("❌ Error in verification update:", err);
    toast.error("Something went wrong while updating verification status.");
  }
   finally {
    setVerifyingId(null); // End loader
  }
};



const menuAnchorsRef = useRef({});
const [anchorEl, setAnchorEl] = useState(null);
const [menuRowId, setMenuRowId] = useState(null);


const handleViewClick = async () => {
  if (!menuRowId) return;

  try {
    setLoading(true);
    const res = await fetch(`${BASE_URL}/company-admins/${menuRowId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const json = await res.json();
    if (!json.error && json.data?.company_admin) {
      setSelectedRow(json.data.company_admin);
    } else {
      toast.error("Failed to fetch company admin details");
    }
  } catch (err) {
    toast.error("Error fetching details");
  } finally {
    setLoading(false);
    setAnchorEl(null); // close menu
  }
};

const handleMessagesClick = () => {
  if (!menuRowId) return;
  
  const selectedCompanyAdmin = tableRows.find(row => row.id === menuRowId);
  if (selectedCompanyAdmin) {
    navigate('/messages', {
      state: {
        openChatWith: {
          id: selectedCompanyAdmin.id,
          name: selectedCompanyAdmin.admin,
          email: selectedCompanyAdmin.email,
        },
        chatType: 'company_admin'
      }
    });
  }
  setAnchorEl(null);
};

// true if any filter set

const clearFilters = () => {
  const clearedFilters = {
    subscription_plan: '',
    subscription_status: '',
    verification_status: '',
    start_date: '',
    end_date: '',
    country:'',
    state:'',
    city:''
  };
  setFilters(clearedFilters);
  setPage(0);
};

const fetchAllInactiveCompanies = async () => {
  const queryParams = new URLSearchParams({
    no_pagination: "true",
    status: "inactive",
    sort_by: sortConfig.key || "date",
    sort_order: sortConfig.direction.toUpperCase() || "DESC",
  });

  if (searchTerm) {
    queryParams.append("search", searchTerm);
  }

  if (filters.subscription_plan) {
    queryParams.append("subscription_plan", filters.subscription_plan);
  }
  // COUNTRY filter
if (filters.country) {
  queryParams.append('country', filters.country);
}

// STATE filter (province → state for backend)
if (filters.state) {
  queryParams.append('state', filters.state);
}

// CITY filter
if (filters.city) {
  queryParams.append('city', filters.city);
}
  if (filters.subscription_status) {
    queryParams.append("subscription_status", filters.subscription_status);
  }
  if (filters.start_date) {
    queryParams.append("start_date", filters.start_date);
  }
  if (filters.end_date) {
    queryParams.append("end_date", filters.end_date);
  }

  const res = await fetch(
    `${BASE_URL}/company-admins?${queryParams.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  const result = await res.json();
  const admins = result?.data?.company_admins || [];

  return admins.map((admin) => ({
    id: admin.id,
    admin: admin.full_name,
    company: admin.company_name,
    country: admin.country,
    active: admin.current_employees,
    usage: admin.max_employees,
    subscription:
      typeof admin.subscription_plan === "string"
        ? admin.subscription_plan
        : typeof admin.subscription_plan === "object"
        ? Object.keys(admin.subscription_plan)[0] || "N/A"
        : "N/A",
    details:
      admin.subscription_status === "trial"
        ? "Trial Ended"
        : "Subscription Ended",
    status: (admin.status || "").toLowerCase(),
    verificationStatus: (admin.verification_status || "").toLowerCase(),
 date: convertUTCToLocalDateTime(admin.created_at),
  }));
};
const getStatusConfig = (status) => {
  switch (status) {
    case "active":
      return {
        showArrow: true,
        options: ["Inactive"],
        disabled: false,
      };

    case "invited":
    case "requested":
      return {
        showArrow: true,
        options: ["active", "inactive"],
        disabled: false,
      };

    case "inactive":
      return {
        showArrow: true,
        options: ["active"],
        disabled: false,
      };

    default:
      return {
        showArrow: false,
        options: [],
        disabled: true,
      };
  }
};

const getVerificationConfig = (status) => {
  if (status === "pending") {
    return {
      showArrow: true,
      options: [ "verified", "rejected"],
      disabled: false,
    };
  }

  return {
    showArrow: false,
    options: [],
    disabled: true,
  };
};


const mapFilters = {
  verification_status: filters.verification_status,
  start_date: filters.start_date,
  end_date: filters.end_date,
  country: filters.country,
  state: filters.state,
  city: filters.city,
   subscription_status: filters.subscription_status,
      trial_end_date_from: filters.trial_end_date_from,
  trial_end_date_to: filters.trial_end_date_to,

  subscription_start_date_from: filters.subscription_start_date_from,
  subscription_start_date_to: filters.subscription_start_date_to,
};

  return (
    <Box sx={{ py:2,px:1}}>
    
      <Toaster/>
     
  {loading ? (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'calc(100vh - 120px)',
    }}
  >
    <CircularProgress sx={{ color: '#006EC2' }} size={40} thickness={4} />
  </Box>
) : selectedRow ? (
  <InactiveDetails selectedRow={selectedRow} onClose={() => setSelectedRow(null)} />
) : (
  <>
    <Box sx={{mb:2,}}>
      <InActivePins selectedClientId={selectedClientId} 
      onClearClientId={() => setSelectedClientId(null)} 
        filters={mapFilters}
  page={page}
  limit={rowsPerPage}
  search={searchTerm}
  />
      </Box>
      
      <Box sx={{ backgroundColor: '#fff', borderRadius: 2, py: 2, border: '1px solid #E4E6EF' }}>

<Box
  sx={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: 2,
    mb: 2,
    flexWrap: 'wrap',
    rowGap: 1,
  }}
>

               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
     <CustomText sx={{ ...textStyles.h1, fontWeight: 600, fontSize: "18px", color: "#003149", textAlign: "left" }}>
{t('inactiveCompanies.title')}
  </CustomText>
  
{tableProcessing && (
    <CircularProgress
      size={18}
      thickness={4}
      sx={{ color: '#006EC2' }}
    />
  )}
  </Box>

  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      flexWrap: 'wrap',
      flexGrow: 1,
      justifyContent: selected.length === 0 ? 'center' : 'flex-end',
    }}
  >
    {
    selected.length > 0 ? (

     statusOptions.map(({ label, value }) => (
     <Button
           key={label}
           onClick={() => handleStatusUpdate(value)}
           variant="contained"
           size="small"
           sx={{
             px: 2,
             height: 34,
             fontSize: 13,
             fontWeight: 400,
             fontFamily: 'Poppins, sans-serif',
             borderRadius: '4px',
             textTransform: 'none',
             backgroundColor: statusButtonStyles[value]?.backgroundColor,
             color: statusButtonStyles[value]?.color,
             '&:hover': {
               backgroundColor: statusButtonStyles[value]?.backgroundColor,
               opacity: 0.9,
             },
           }}
         >
            {statusUpdating === value && (
             <CircularProgress
               size={16}
               thickness={4}
               sx={{ color: statusButtonStyles[value]?.color, mr: 1 }}
             />
           )}
           {label}
         </Button>
      ))
    ) : (

      <>
        <Box
          sx={{
            mx: 'auto',
            px: 0.5,
            py: 0.2,
            borderRadius: 1,
            height: 34,
            border: '2px solid #091E4224',
            display: 'flex',
            alignItems: 'center',
            minWidth: 250,
          }}
        >
          <InputBase
            value={searchTerm}
  onChange={(e) => {
    setSearchTerm(e.target.value);
    setPage(0);
  }}
            placeholder={t('adminNameEmail')}
            sx={{
              ml: 0.5,
              fontSize: 15,
              letterSpacing: '1px',
              color: '#939393',
              fontWeight: 500,
              width: '100%',
            }}
          />
          <SearchIcon sx={{ fontSize: 22, color: '#888', mr: 0.5 }} />
        </Box>

<ExportDropdown
  onDownloadPDF={async () => {
    const allData = await fetchAllInactiveCompanies(); // 👈 fetch full filtered data
    const blobStream = pdf(<InactiveCompaniesPDF data={allData} />).toBlob();
    blobStream.then((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Inactive_Clients_Report_${new Date()
        .toISOString()
        .slice(0, 10)}.pdf`;
      link.click();
    });
  }}
  onDownloadExcel={async () => {
    const allData = await fetchAllInactiveCompanies(); // 👈 fetch full filtered data
    ExportInactiveCompaniesExcel(allData);
  }}
/>

      {isFilterApplied ? (
  <Box
    sx={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 34,
      height: 34,
      borderRadius: 1,
      bgcolor: "#006EC2", // blue background when filter applied
    }}
  >
    {/* Filter Icon */}
    <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />

    {/* Small Cross Badge */}
    <IconButton
      size="small"
      onClick={clearFilters}
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        bgcolor: "white",
        width: 18,
        height: 18,
        border: "1px solid #C4C4C4",
        "&:hover": { bgcolor: "#f5f5f5" },
      }}
    >
      <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
    </IconButton>
  </Box>
) : (
  <IconButton
    onClick={() => setFilterDrawerOpen(true)}
    sx={{
      border: "1px solid #C4C4C4",
      borderRadius: 1,
      width: 34,
      height: 34,
      backgroundColor: "white",
      color: "#5E5C5C",
      "&:hover": { backgroundColor: "#F2F2F2" },
    }}
  >
    <FilterAltIcon sx={{ fontSize: 22 }} />
  </IconButton>
)}

      </>
    )}
  </Box>
</Box>

        <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
          <Table size="small">
  
            <TableHead sx={{
                whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
            }}>
  <TableRow>

    {columns.map((col) => (
      <TableCell key={col.key} sx={{ ...HaederStyles, py: '6px', px: '2px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: col.key === 'action' ? 'flex-start' : 'center' }}>
          {col.label}
          {col.key !== 'action' && (
            <IconButton size="small" onClick={() => handleSort(col.key)}>
              {sortConfig.key === col.key && sortConfig.direction === 'asc' ? (
                <NorthIcon sx={{ fontSize: '12px' }} />
              ) : (
                <SouthIcon sx={{ fontSize: '12px' }} />
              )}
            </IconButton>
          )}
        </Box>
      </TableCell>
    ))}
  </TableRow>
</TableHead>
<TableBody>
  {tableRows.length === 0 ? (
    <TableRow>
      <TableCell colSpan={columns.length + 1}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: 300,
          }}
        >
          <img src={emptyscreen} alt="No Data" style={{ width: 200 }} />
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 500,
              fontSize: "16px",
              color: "#003149",
              pt: 1,
            }}
          >
            {t("empty.no_user")}
          </CustomText>
        </Box>
      </TableCell>
    </TableRow>
  ) : (
    tableRows.map((row, index) => {
      const {
        showArrow: statusShowArrow,
        options: statusOptions,
        disabled: statusDisabled,
      } = getStatusConfig(row.status);

      const {
        showArrow: verificationShowArrow,
        options: verificationOptions,
        disabled: verificationDisabled,
      } = getVerificationConfig(row.verificationStatus);

      return (
        <TableRow
          key={row.id}
          hover
          onClick={() => setSelectedClientId(row.id)}
          sx={{ cursor: "pointer" }}
        >
          <TableCell sx={{ ...DataStyles, pl: 1 }}>{row.id}</TableCell>

          <TableCell sx={{ ...DataStyles }}>
            <CustomText sx={{ fontSize: 13, fontWeight: 500 }}>
              {row.admin || "-- "}
            </CustomText>
            <CustomText sx={{ fontSize: 12, color: "#5A5A5A" }}>
              {row.email|| "-- "}
            </CustomText>
          </TableCell>

          <TableCell sx={{ ...DataStyles }}>{row.company || "-- "}</TableCell>
          <TableCell sx={{ ...DataStyles }}>{row.country || "-- "}</TableCell>
          <TableCell sx={{ ...DataStyles }}>{row.businessEmail}</TableCell>
          <TableCell sx={{ ...DataStyles, textAlign: "center" }}>
            {row.active || "-- "}
          </TableCell>
          <TableCell sx={{ ...DataStyles }}>{row.usage || "-- "}</TableCell>

          <TableCell sx={{ ...DataStyles }}>
            {Array.isArray(row.subscription)
              ? row.subscription.join(", ")
              : String(row.subscription).replace(/[\[\]{}"]/g, "")}
          </TableCell>
<TableCell sx={{ ...DataStyles, width: 120 , textTransform: "capitalize" }}>
  {(row.subscriptionStatus || "-- ").replace(/_/g, " ")}
</TableCell>
          <TableCell sx={{ ...DataStyles }}>{row.details || "-- "}</TableCell>

          {/* STATUS */}
          <TableCell sx={{ textAlign: "center" }}>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                px: 0.6,
                py: 0.1,
                borderRadius: 1,
                backgroundColor:
                  statusButtonStyles[row.status]?.backgroundColor,
                color: statusButtonStyles[row.status]?.color,
                pointerEvents: statusDisabled ? "none" : "auto",
                cursor: statusDisabled ? "default" : "pointer",
                opacity: statusDisabled ? 0.9 : 1,
              }}
            >
              <StatusDropdown
                currentStatus={row.status}
                showArrow={statusShowArrow}
                statusOptions={statusOptions}
                onChange={(newStatus) => {
                  if (!statusOptions.includes(newStatus)) return;

                  const updated = [...tableRows];
                  updated[index].status = newStatus;
                  setTableRows(updated);
                }}
              />
            </Box>
          </TableCell>

          {/* VERIFICATION STATUS */}
          <TableCell sx={{ textAlign: "center" }}>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                px: 0.6,
                py: 0.1,
                borderRadius: 1,
                backgroundColor:
                  statusButtonStyles[row.verificationStatus]
                    ?.backgroundColor,
                color:
                  statusButtonStyles[row.verificationStatus]?.color,
                pointerEvents: verificationDisabled ? "none" : "auto",
                cursor: verificationDisabled ? "default" : "pointer",
                opacity: verificationDisabled ? 0.9 : 1,
              }}
            >
              {verifyingId === row.id && (
                <CircularProgress size={12} thickness={4} />
              )}

              <ArrowStatusDropdown
                currentStatus={row.verificationStatus}
                showArrow={verificationShowArrow}
                statusOptions={verificationOptions}
                onChange={(newStatus) => {
                  if (!verificationOptions.includes(newStatus)) return;
                  handleVerificationStatusUpdate(newStatus, row.id);
                }}
              />
            </Box>
          </TableCell>

          <TableCell sx={{ ...DataStyles }}>{row.date}</TableCell>
<TableCell sx={{ ...DataStyles, width: 220 }}>
  {row.subscriptionPeriod}
</TableCell>
<TableCell sx={{ ...DataStyles, width: 220 }}>
  {row.trialPeriod}
</TableCell>
          <TableCell sx={{ width: "100px" }}>
            <IconButton
              ref={(el) => {
                if (el) menuAnchorsRef.current[row.id] = el;
              }}
              onClick={() => {
                setAnchorEl(menuAnchorsRef.current[row.id]);
                setMenuRowId(row.id);
              }}
            >
              <MoreVertIcon fontSize="small" />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    })
  )}
</TableBody>


          </Table>
        </TableContainer>
                                              <Menu
                   sx={{fontSize:"15px",boxShadow:"none"}}
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'center',
  }}
  transformOrigin={{
    vertical: 'top',
    horizontal: 'center',
  }}
                    PaperProps={{
                    sx: {
                      // minWidth: 80,
                      // paddingY: 0.5,
                      // boxShadow:"none",
                      // border: '1px solid #E0E0E0',
                    },
                  }}
                  MenuListProps={{
                    sx: {
                      paddingY: 0,
                    },
                  }}
                >
                  <MenuItem onClick={handleViewClick} sx={{fontSize:"14px",
                       fontFamily: 'Poppins, sans-serif',
                  }}>{t("common.view")}</MenuItem>

 <MenuItem onClick={handleMessagesClick} sx={{fontSize:"14px",
       fontFamily: 'Poppins, sans-serif',
  }}>{t("messages")}</MenuItem>
                </Menu>

            <Box sx={{ display: 'flex',flexWrap:"wrap", justifyContent: 'center', mt: 2 }}>
            <Pagination
  count={totalPages}
  page={page + 1}
  onChange={(e, value) => setPage(value - 1)}
  shape="rounded"
  color="primary"
  size="small"
  sx={{
    '& .MuiPaginationItem-root': {
      fontFamily: 'Poppins, sans-serif',
      fontSize: 13,
      fontWeight: 500,
    },
    '& .Mui-selected': {
      backgroundColor: '#E9F3FF',
      color: '#006EC2',
    },
  }}
/>
</Box>
      </Box>
        </>
      )}
<FilterDrawer
  open={filterDrawerOpen}
  onClose={() => setFilterDrawerOpen(false)}
  filters={filters}
  setFilters={setFilters}
  onApplyFilters={(updatedFilters) => {
     console.log("📤 Filters applied:", updatedFilters);
    setFilters(updatedFilters);
    setPage(0);
    fetchInactiveCompanies(0, rowsPerPage, sortConfig.key || 'email', sortConfig.direction || 'asc', false, searchTerm, updatedFilters);
    setFilterDrawerOpen(false);
  }}

/>


    </Box>
  );
};

export default InactiveCompanies;












